import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { loading: false, data: [], error: "", message: "" }


export const getMetaAction = createAsyncThunk(
    'get-meta',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/get-meta`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getMetaSlice = createSlice({
    name: 'get-meta',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getMetaAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getMetaAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.message = action?.payload?.message
            })
            builder.addCase(getMetaAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.message = action?.payload?.message
            })
        },

})



export const getMetaReducer = getMetaSlice.reducer    